import React, { useState, useEffect } from "react";
import styles from "../../asset/Affiliations/Affiliations.module.scss";
import Imgage1 from "../../asset/homefour/clientsimg/001.png"
import Imgage2 from "../../asset/homefour/clientsimg/002.png"
import Imgage3 from "../../asset/homefour/clientsimg/003.png"

import Imgage4 from "../../asset/homefour/clientsimg/004.png"
import Imgage5 from "../../asset/homefour/clientsimg/005.png"
import Imgage6 from "../../asset/homefour/clientsimg/006.png"
import Imgage7 from "../../asset/homefour/clientsimg/007.png"
import Imgage8 from "../../asset/homefour/clientsimg/008.png"
import Imgage9 from "../../asset/homefour/clientsimg/009.png"


const Affiliations = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const affiliations = [
        { id: 1, image: Imgage1, alt: "Advertising Specialty Institute" },
        { id: 2, image: Imgage2, alt: "SGIA" },
        { id: 3, image: Imgage3, alt: "ISS" },
        { id: 4, image: Imgage4, alt: "Partner Organization" },
        { id: 5, image: Imgage5, alt: "Partner Organization" },
        { id: 6, image: Imgage6, alt: "Partner Organization" },
        { id: 7, image: Imgage7, alt: "Partner Organization" },
        { id: 8, image: Imgage8, alt: "Partner Organization" },
        { id: 9, image: Imgage9, alt: "Partner Organization" }

    ];

    // Create extended array for infinite loop
    const extendedAffiliations = [...affiliations, ...affiliations];

    const nextSlide = () => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentSlide(prev => prev + 1);
    };

    const prevSlide = () => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentSlide(prev => prev - 1);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isTransitioning) {
                nextSlide();
            }
        }, 3000);
        return () => clearInterval(interval);
    }, [isTransitioning]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTransitioning(false);
            if (currentSlide >= affiliations.length) {
                setCurrentSlide(0);
            } else if (currentSlide < 0) {
                setCurrentSlide(affiliations.length - 1);
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [currentSlide, affiliations.length]);

    return (
        <section className={styles.affiliationsSection}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Our Trusted Client's</h2>
                    <p className={styles.subtitle}>Partnering with industry leaders to deliver excellence</p>
                </div>

                <div className={styles.carouselContainer}>
                    <button className={`${styles.navButton} ${styles.prevButton}`} onClick={prevSlide}>
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                        </svg>
                    </button>

                    <div className={styles.carousel}>
                        <div
                            className={styles.carouselTrack}
                            style={{
                                transform: `translateX(-${currentSlide * 100}%)`,
                                transition: isTransitioning ? 'transform 0.5s ease' : 'none'
                            }}
                        >
                            {extendedAffiliations.map((affiliation, index) => (
                                <div key={`${affiliation.id}-${index}`} className={styles.carouselSlide}>
                                    <img
                                        src={affiliation.image}
                                        alt={affiliation.alt}
                                        className={styles.affiliationImage}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <button className={`${styles.navButton} ${styles.nextButton}`} onClick={nextSlide}>
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                        </svg>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Affiliations;
